import React, { Component } from 'react';
import { withRouter, Redirect, Link } from "react-router-dom";
import { Text, View, Image, ScrollView, Platform } from 'react-native';
import SignIn from '../../native/screens/sign-in'; 
import ReactGA from 'react-ga';
import { helpers } from '../../native/utils/helpers';
import AuthenticationWrapper from '../../native/components/authentication-wrapper';
import Auth0 from 'react-native-auth0';
import { bindActionCreators } from 'redux';
import { setUserToken } from '../../redux/User/user.actions';
import { connect } from 'react-redux';
import apiHelpers from "../../native/utils/api-helpers";
import Loader from '../../native/components/loader/index.js';

export class SignInScreen extends Component {    
    constructor(props){
        super(props);

        let redirectUrl = null;
        let verifyRedirectUrl = null;
        let allParams = null;
        let webView = helpers.isWeb();
        let redirectParams = null;
        if (webView && process.browser && window.location.search.includes("redirect=")) {
            let searchArr = window.location.search.replace("?", "").split("&");
            let foundSearch = searchArr.find((searchParam) => {
                return searchParam.includes("redirect=");
            });
            redirectParams = searchArr.find((searchParam) => {
                return searchParam.includes("redirect-params=");
            });
            if (foundSearch) {
                let search = foundSearch.replace("redirect=", "");
                redirectUrl = (search != '') ? search : null;
                verifyRedirectUrl = redirectUrl;
            }
        } else if (!webView && this.props.route.params) {
            redirectUrl = (this.props.route.params.redirect) ? this.props.route.params.redirect : null;
            verifyRedirectUrl = (this.props.route.params.verifyRedirect) ? this.props.route.params.verifyRedirect : null;
            allParams = this.props.route.params;
        }
        if (redirectParams) {
            redirectUrl = redirectUrl + '?' + redirectParams
        }
        
        this.state = {
            searchQuery: "",
            locationHash: "",
            userIpAddress: "",
            enableBtnLoader: false,
            redirectUrl: redirectUrl,
            verifyRedirectUrl: verifyRedirectUrl,
            allParams: allParams
        }
        if(process.browser) {
            try {
                ReactGA.pageview(this.props.history.location.pathname);
            }
            catch(error) {
                console.log("GA tracking error =>", error);
            }
        }
    }

    getIpAccessInfo = async () => {
        const endpoint = `/verify-ip-access`
        let body = {}
        try{
            const ipInfo = await apiHelpers.apiRequest(endpoint, body, "POST", true, false)
            if(ipInfo.instituteAccess === true){
                return {
                    institute_access: true,
                }
            }
        }
        catch(err){
            console.log('IP error: ', err)
        }
        return false
    }


    componentDidMount = () => {
        const { login } = this.props.auth;
        const redirectTo = this.state.redirectUrl;
        let defaultParams = {appState: { returnTo: redirectTo}}
        login({...defaultParams});
        // setTimeout(function () {
        //     window.history.scrollRestoration = "manual";
        //     document.body.style.overflow = 'hidden';
        //     document.body.style.position = 'fixed';
        //     setTimeout(function () {
        //         document.body.style.overflow = 'initial';
        //         document.body.style.position = 'initial';
        //     }, 20);
        // }, 20);
        // if(window.location.search != this.state.searchQuery) {
        //     this.setState({
        //         searchQuery: window.location.search
        //     })
        // }
        // if(window.location.hash != this.state.locationHash) {
        //     this.setState({
        //         locationHash: window.location.hash
        //     })
        // }
    }

    componentDidUpdate = () => {
        // if(window.location.search != this.state.searchQuery) {
        //     this.setState({
        //         searchQuery: window.location.search
        //     })
        // }
        // if(window.location.hash != this.state.locationHash) {
        //     this.setState({
        //         locationHash: window.location.hash
        //     })
        // }
    }
    
    // navigateToScreen = (route, params) => {
    //     let routeArr = route.split('?')
    //     const { history } = this.props;
    //     history.push({
    //       pathname: routeArr[0],
    //       search: routeArr[1] ? ('?' + routeArr[1]) : '',
    //       state: params
    //     });
    // }


    render(){
        
        // const { searchQuery, locationHash } = this.state;
        return (
            <View style={{ flexDirection: 'row', height: '100%', alignItems: 'center', justifyContent: 'center', position: 'absolute', width: '100%' }}>
                <Loader title={"Please wait while we sign you in ..."}/>
            </ View>
        )
        // return(
        //    <>{(process.browser || !this.props.token) ? <SignIn history={this.props.history} searchQuery={searchQuery} locationHash={locationHash} navigateToScreen={this.navigateToScreen} /> : <></>}</>
        // );
    }
}

const mapStateToProps = (state) => {
    const { app, user } = state;
    return { app, user }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ setUserToken }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthenticationWrapper(SignInScreen));
